import React, { useState } from 'react';
import { Button } from "@/components/ui/button";

interface LargeTextProps {
  text?: string;
  initialLines?: number;
}

const LargeText: React.FC<LargeTextProps> = ({ text = '', initialLines = 2 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  const lines = text.split('\n');

  return (
    <div>
      <p className={`text-justify text-muted-foreground ${isExpanded ? '' : `line-clamp-${initialLines}`}`}>
        {text}
      </p>
      {lines.length > initialLines && (
        <Button 
          variant='link' 
          size='sm' 
          onClick={toggleReadMore} 
          className="text-muted-foreground"
        >
          {isExpanded ? 'Read less...' : 'Read more...'}
        </Button>
      )}
    </div>
  );
};

export default LargeText;